var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "files-upload-form" }, [
    _c("div", { staticClass: "files-upload-form--title" }, [
      _vm._v(_vm._s(_vm.$t("Account.UploadCenter.Form.Title")))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "files-upload-form--filetypes" }, [
      _vm._v(_vm._s(_vm.$t("Account.UploadCenter.Form.AcceptedFileTypes")))
    ]),
    _vm._v(" "),
    _c(
      "form",
      {
        attrs: { enctype: "multipart/form-data" },
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.uploadFiles.apply(null, arguments)
          }
        }
      },
      [
        _vm._l(_vm.numberOfFiles, function(_, index) {
          return _c("div", { key: index, staticClass: "upload-item" }, [
            _c("input", {
              ref: "fileInputs",
              refInFor: true,
              staticClass: "file-input-hidden",
              attrs: { type: "file", disabled: _vm.successInputs[index] },
              on: {
                change: function($event) {
                  return _vm.onFileChange($event, index)
                }
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "file-input-visual",
                class: {
                  disabled: _vm.successInputs[index],
                  "upload-error": _vm.errorInputs[index]
                },
                on: {
                  click: function($event) {
                    return _vm.openFilePicker(index)
                  }
                }
              },
              [
                _c("span", { staticClass: "file-input-text" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.getFileInputText(index)) +
                      "\n        "
                  )
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "file-input-icon" }, [
                  _vm.errorInputs[index] && !_vm.successInputs[index]
                    ? _c(
                        "svg",
                        {
                          staticClass: "file-input-icon--error",
                          attrs: {
                            width: "23",
                            height: "23",
                            viewBox: "0 0 23 23",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg"
                          }
                        },
                        [
                          _c("circle", {
                            attrs: {
                              cx: "11.5",
                              cy: "11.5",
                              r: "10",
                              stroke: "#FF4848",
                              "stroke-width": "3"
                            }
                          }),
                          _vm._v(" "),
                          _c("line", {
                            attrs: {
                              x1: "8.12132",
                              y1: "8",
                              x2: "15",
                              y2: "14.8787",
                              stroke: "#FF4848",
                              "stroke-width": "3",
                              "stroke-linecap": "round"
                            }
                          }),
                          _vm._v(" "),
                          _c("line", {
                            attrs: {
                              x1: "15",
                              y1: "8.12132",
                              x2: "8.12132",
                              y2: "15",
                              stroke: "#FF4848",
                              "stroke-width": "3",
                              "stroke-linecap": "round"
                            }
                          })
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.successInputs[index]
                    ? _c(
                        "svg",
                        {
                          staticClass: "file-input-icon--upload",
                          attrs: {
                            width: "20",
                            height: "18",
                            viewBox: "0 0 20 18",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg"
                          }
                        },
                        [
                          _c("line", {
                            attrs: {
                              x1: "1.5",
                              y1: "16.4091",
                              x2: "17.5",
                              y2: "16.4091",
                              stroke: "#4A597E",
                              "stroke-width": "3",
                              "stroke-linecap": "round"
                            }
                          }),
                          _vm._v(" "),
                          _c("line", {
                            attrs: {
                              x1: "1.5",
                              y1: "10.7727",
                              x2: "1.5",
                              y2: "16.4091",
                              stroke: "#4A597E",
                              "stroke-width": "3",
                              "stroke-linecap": "round"
                            }
                          }),
                          _vm._v(" "),
                          _c("line", {
                            attrs: {
                              x1: "17.9091",
                              y1: "10.7727",
                              x2: "17.9091",
                              y2: "16.4091",
                              stroke: "#4A597E",
                              "stroke-width": "3",
                              "stroke-linecap": "round"
                            }
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M9.5 12.7273L9.5 1.50002",
                              stroke: "#4A597E",
                              "stroke-width": "3",
                              "stroke-miterlimit": "11.4737",
                              "stroke-linecap": "round"
                            }
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M14.6818 6.68188L9.49994 1.50007",
                              stroke: "#4A597E",
                              "stroke-width": "3",
                              "stroke-miterlimit": "11.4737",
                              "stroke-linecap": "round"
                            }
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M4.31824 6.68188L9.50006 1.50007",
                              stroke: "#4A597E",
                              "stroke-width": "3",
                              "stroke-miterlimit": "11.4737",
                              "stroke-linecap": "round"
                            }
                          })
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.errorInputs[index] && _vm.successInputs[index]
                    ? _c(
                        "svg",
                        {
                          staticClass: "file-input-icon--success",
                          attrs: {
                            width: "22",
                            height: "22",
                            viewBox: "0 0 22 22",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg"
                          }
                        },
                        [
                          _c("path", {
                            attrs: {
                              d:
                                "M11 0C4.92303 0 0 4.92303 0 11C0 17.077 4.92303 22 11 22C17.077 22 22 17.077 22 11C22 4.92303 17.0736 0 11 0ZM11 19.9379C6.06331 19.9379 2.06207 15.9367 2.06207 11C2.06207 6.06331 6.06331 2.05866 11 2.05866C15.9367 2.05866 19.9379 6.0599 19.9379 10.9966C19.9379 15.9333 15.9367 19.9345 11 19.9345V19.9379Z",
                              fill: "#00D828"
                            }
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d:
                                "M8.80401 17.3305L4.41273 12.8786C3.86226 12.3206 3.86226 11.4169 4.41273 10.862C4.96321 10.3039 5.8546 10.3039 6.40194 10.862L8.80401 13.2972L14.9311 7.08554C15.4816 6.52748 16.373 6.52748 16.9204 7.08554C17.4708 7.64361 17.4708 8.54729 16.9204 9.10219L8.80401 17.3337V17.3305Z",
                              fill: "#00D828"
                            }
                          })
                        ]
                      )
                    : _vm._e()
                ])
              ]
            )
          ])
        }),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.$t("Account.UploadCenter.Form.Notice")))]),
        _vm._v(" "),
        _c(
          "div",
          { staticStyle: { "text-align": "center" } },
          [
            _c(
              "v-btn",
              {
                attrs: {
                  type: "submit",
                  disabled: _vm.isSubmitDisabled,
                  color: "success",
                  "x-large": ""
                }
              },
              [_vm._v(_vm._s(_vm.$t("Account.UploadCenter.Form.Submit")))]
            )
          ],
          1
        )
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35e7b7d6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35e7b7d6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/UploadCenter/FilesUploadForm.vue
// module id = null
// module chunks = 